module.exports = __webpack_public_path__ + "img/mouth_male_thick_mask.13112903.png";